import { Button } from '@mui/material';
import logo from '../assets/img/logo.svg';
import { MenuBtn } from "./MenuBtn";
import { useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

const pagination = [
    {
        id: 'about us',
        path: '#about'
    },
    {
        id: 'our services',
        path: '#services'
    },
]


const spyOpt =['home', 'about', 'services'];

export const NavBar = ({path, packFunc}) =>{

    const [openMenu, setOpenMenu] = useState(false);

    const handleNavMenu = () =>{
        setOpenMenu(oldValue => !oldValue )
    }
    const handleFreePack =()=>{
        packFunc('Free consult');
        setOpenMenu(oldValue => !oldValue )
    }




    return(
        <>
            <nav className=' flex flex-wrap py-4 items-center gap-4 justify-between fixed top-0 z-50 bg-[var(--backgrd)] w-full'>
                <Link to="#" className="logo leading-none">
                    <img src={logo} alt="our logo" className="logo h-[1.5rem]" />
                </Link>
                <div className={`nav-links ${openMenu? 'flex' : ' hidden'} min-[1024px]:flex items-center flex-col min-[1024px]:flex-row  absolute min-[1024px]:static  top-full min-[1024px]:top-auto  right-[var(--margin)] min-[1024px]:right-auto bg-[#141414] min-[1024px]:bg-transparent border border-[#888888] min-[1024px]:border-transparent rounded-sm p-4 min-[1024px]:p-0 transition-all duration-500 ease-in-out gap-6 min-[1024px]:gap-12 z-10 `}>
                    <div className="nav-links flex flex-wrap items-center flex-col min-[1024px]:flex-row gap-2">
                    
                    {
                        pagination.map((page, i) =>(
                            <Link 
                                to={page.path} 
                                key={page.id} 
                                className='p-2 uppercase font-medium text-[var(--text-l)] hover:text-[var(--text-h)] transition-all duration-500 ease-in-out' 
                                data-to-scrollspy-id={spyOpt[i]}
                            >
                                {page.id}
                            </Link>
                        ))
                    }
                        <a 
                            href="https://portfoliobyfade.netlify.app/"
                            target='blank'
                            className='p-2 uppercase font-medium text-[var(--text-l)] hover:text-[var(--text-h)] transition-all duration-500 ease-in-out'
                        >
                            our work
                        </a>
                        
                    </div>
                    
                    <Button 
                        variant="contained"
                        sx={{backgroundColor : '#FFFFFF', color: '#0A0A0A',
                            '&:hover': {color : '#FFFFFF', backgroundColor:'#141414' }
                        }}
                        onClick={handleFreePack}
                    >
                        <p className=' font-bold'>
                            get free consultation
                        </p>
                    </Button>
                </div>
                <span className='block min-[1024px]:hidden animate-pulse duration-500 ease-in-out h-fit lg:h-[32px]'>
                    <Button 
                        variant="text"  
                        onClick={handleNavMenu}
                    >
                        <MenuBtn activeMenu={openMenu} />
                    </Button>
                </span>
                
            </nav>
        </>
    )
}